import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import { StoreContext } from '../../../appContext/StoreProvider';
import { SEOUtils } from '../../../../utils/SEO';
import { isClientSide } from '../../../../common/utils';

export const SEOCanonicalLink = ({ staticContext = {} }) => {
  const { store } = React.useContext(StoreContext);
  const host = isClientSide() ? window.location.host : staticContext.host;
  const location = useLocation();
  const basename = store.storePath;
  const { title, description, canonicalLink } = SEOUtils(
    {
      host,
      basename,
      pathname: location.pathname,
    },
    store.viewer.viewerConfig.seoConfig,
    store.getFullTree(),
  );

  return (
    <Helmet>
      <link rel="canonical" href={canonicalLink} />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};
